import { get } from 'lodash'
import {
  DELIVERY_TYPES,
  PAYMENT_TYPES,
  ONLINE_PAYMENT_TYPES,
  PARENTAL_FIELDS
} from 'constants/enums'

export default function(fields = {}, localeId = 2) {
  try {
    const profileQuestionAnswers = get(fields, 'profileQuestionAnswers')
    const { postal, ...rest } = fields

    const data = {
      ...rest,
      profileQuestionAnswers:
        profileQuestionAnswers && profileQuestionAnswers.filter(item => item),
      localeId,
      agreementPrivacyPolicy: get(
        fields,
        'helpers.agreementPrivacyPolicy',
        false
      ),
      isGivenConsentForPhotoUse: get(fields, 'helpers.photosConsent', false),
      passwordHash: undefined,
      helpers: undefined,
      previousCompletedAwardLevel: fields.previousCompletedAwardPlace
        ? fields.previousCompletedAwardLevel
        : undefined,
      secondaryEmailAgain: undefined,
      emailAgain: undefined
    }

    if (get(fields, 'helpers.hasProfileQuestions') === false) {
      data.profileQuestionAnswers = undefined
    }

    if (get(fields, 'helpers.isUnderAge') === false) {
      // If users fills in parental first and later changes that he's not under age, clear the parental fields
      PARENTAL_FIELDS.map(key => {
        if (key in data) {
          data[key] = undefined
        }
      })
    }

    if (get(fields, 'paymentType.value') === PAYMENT_TYPES.online.id) {
      data.onlinePaymentType = {
        value: ONLINE_PAYMENT_TYPES.masterCard.id,
        translationText: ONLINE_PAYMENT_TYPES.masterCard.label
      }
    }

    if (!get(fields, 'awardLevel.value')) {
      data.awardLevel = {
        value: undefined
      }
    }

    if (get(fields, 'helpers.knownLeader') === 'no') {
      data.awardLeaderId = null
    }

    console.log('creating scheme')

    if (get(fields, 'helpers.postalAddressChecked')) {
      data.postalCountryId = postal.addressCountryId
      data.postalLine1 = postal.line1
      data.postalLine2 = postal.line2
      data.postalZipCode = postal.zipCode
      data.postalCity = postal.city
      data.postalStateOrProvinceOrRegion = postal.stateOrProvinceOrRegion
    }

      if (fields.addressCountryId) {
      data.addressCountryId= fields.addressCountryId
    }


    // hack - need to refactor Parent step - before start and paper => both should have paper value === issue with radio select
    if (
      get(fields, 'consentDeliveryType.value') ===
      DELIVERY_TYPES.NOT_REQUIRED.value
    ) {
      data.consentDeliveryType.value = DELIVERY_TYPES.PAPER.value
    }

    if (get(fields, 'helpers.price') !== PAYMENT_TYPES.onlineManual.id) {
      data.enteredTransactionId = undefined
    }

    return data
  } catch (err) {
    throw Error('Error creating scheme', err)
  }
}
